export function normalizeText(value: unknown): string {
    return String(value ?? '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase();
  }

/**
 * Gera um username no formato `nome.sobrenome` a partir de um nome completo.
 *
 * Exemplos:
 *  - "João da Silva"  → "joao.silva"
 *  - "Ana"           → "ana"
 *  - "Carlos Eduardo Ribeiro" → "carlos.ribeiro"
 */
export function generateUsername(fullName: string): string {
  const parts = normalizeText(fullName)
    .replace(/[^a-z\s]/g, '')   // remove caracteres não-alfabéticos (exceto espaço)
    .split(/\s+/)               // separa por espaços
    .filter(Boolean);           // remove strings vazias

  if (parts.length === 0) return '';
  if (parts.length === 1) return parts[0];

  return `${parts[0]}.${parts[parts.length - 1]}`;
}

/**
 * Divide um nome completo em primeiro nome e sobrenome, preservando acentos.
 * O primeiro token é o `firstName`; todo o resto vira `lastName`.
 *
 * Exemplos:
 *  - "João da Silva"          → { firstName: 'João', lastName: 'da Silva' }
 *  - "Ana"                    → { firstName: 'Ana', lastName: '' }
 *  - "Carlos Eduardo Ribeiro" → { firstName: 'Carlos', lastName: 'Eduardo Ribeiro' }
 */
export function splitFullName(fullName: string): { firstName: string; lastName: string } {
  const parts = String(fullName ?? '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  return {
    firstName: parts[0] ?? '',
    lastName: parts.slice(1).join(' '),
  };
}